<div class="dialog-wrapper custom-dialog-wrapper">
  <div class="header-access-card-dialog">
    <h2 mat-dialog-title> {{lextranslate.i18n["7c10aa01-492f-423a-a673-0f1a4c117f0c"]}}</h2>
    <button mat-icon-button aria-label="Close button" [mat-dialog-close]="null">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="mat-typography">
    <p>{{lextranslate.i18n["e8358ff0-19d0-4c33-a9a3-c5f4fd71c3ef"]}}</p>

    <ng-select [items]="options" bindLabel="nome" bindValue="id" [multiple]="true" [(ngModel)]="selected"
      [appendTo]="'body'" [closeOnSelect]="false" placeholder="Selecione uma ou mais opções">

      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <div class="custom-tag">
          <span>{{ item.nome }}</span>
          <i style="font-size: 1.4em;" (click)="clear.call(undefined, item);" class="material-icons">close</i>
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <label class="checkbox" style="pointer-events: none;">
          <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" />
          <span class="input-span"></span>
        </label>
        <b class="custom-option" [style.backgroundColor]="'transparent'" [style.color]="'black'">
          {{ item.nome }}
        </b>
      </ng-template>

    </ng-select>

  </mat-dialog-content>

  <mat-dialog-actions class="dialog-buttons" align="center">
    <button mat-button mat-dialog-close class="dialog-button back-button" [mat-dialog-close]="null">
      {{ lextranslate.i18n["1deff2f1-f5ae-453b-a963-6d67417e456d"] }}
    </button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="dialog-button confirm-button"
      [mat-dialog-close]="selected" [disabled]="selected.length === 0">
      {{lextranslate.i18n["b79a5585-74b6-416e-a1cb-e1260d500729"]}}
    </button>
  </mat-dialog-actions>
</div>
